// Check wishlist drawer close to update the cart

// Override ScrollCarousel previous/next to always move 1 slide at a time
// instead of groupCells (which is used only for dots navigation)
(function patchScrollCarousel() {
  const ScrollCarousel = customElements.get('scroll-carousel');
  if (!ScrollCarousel) {
    // Custom element not yet registered; retry after current call stack
    return setTimeout(patchScrollCarousel, 0);
  }

  const { prototype } = ScrollCarousel;

  prototype.previous = function ({ instant = false } = {}) {
    this.select(Math.max(this.selectedIndex - 1, 0), { instant });
  };

  prototype.next = function ({ instant = false } = {}) {
    this.select(Math.min(this.selectedIndex + 1, this.cells.length - 1), { instant });
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  const observeDrawerState = (wishlistDrawer) => {
    const classObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class' && wishlistDrawer.classList.contains('hide')) {
          const itemCount = parseInt(document.querySelector('cart-count').innerText || '0', 10);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.querySelector('.header__cart-count').classList.add('is-visible');
        }
      });
    });

    classObserver.observe(wishlistDrawer, { attributes: true });
  };

  const bindWhenDrawerAppears = () => {
    const wishlistDrawer = document.querySelector('.wishlist-drawer-show');
    if (wishlistDrawer) {
      observeDrawerState(wishlistDrawer);
      return;
    }

    const domObserver = new MutationObserver(() => {
      const dynamicDrawer = document.querySelector('.wishlist-drawer-show');
      if (!dynamicDrawer) {
        return;
      }

      observeDrawerState(dynamicDrawer);
      domObserver.disconnect();
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  };

  bindWhenDrawerAppears();
});
